import { render, staticRenderFns } from "./CustomerUpdate.vue?vue&type=template&id=049757fa&"
import script from "./CustomerUpdate.vue?vue&type=script&lang=js&"
export * from "./CustomerUpdate.vue?vue&type=script&lang=js&"
import style0 from "./CustomerUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports